@use "variables" as *;

.container {
  display: flex;
  width: 100%;
  align-items: flex-start;
  flex-direction: row;
  flex-shrink: 0;
}

.albumImage {
  width: 64px;
  height: auto;
}

.rightContainer {
  display: flex;
  align-self: stretch;
}

.name {
  font-size: $fontSize-m;
  font-weight: 600;
  padding-top: $spacing-xs;
  padding-left: $spacing-m;
}

.subtitle {
  font-size: $fontSize-xs;
  font-weight: normal;
  padding-top: $spacing-xs;
  padding-left: $spacing-m;
}

.card {
  display: flex !important;
  flex-direction: row !important;
  justify-content: flex-start !important;
}
